import { Reducer } from 'redux';
import {
    LOCATION_ERROR,
    LOCATION_CLEAR_ERROR,
    LOCATION_CLEAR_SUCCESS,
    LOCATION_FETCH_START,
    LOCATION_FETCH_SUCCESS,
    LOCATIONS_FETCH_SUCCESS,
    LOCATION_RESET,
    LOCATION_SAVE_START,
    LOCATION_SAVE_SUCCESS,
    LocationAction
} from 'actions/location/LocationActionsTypes';
import { LocationState, LocationStatus } from './LocationState';

const initialState: LocationState = {
    locations: [],
    status: LocationStatus.Initial,
    loading: false,
    pagination: {
        page: 0,
        size: 0,
        totalPages: 0,
        totalRecords: 0
    }
};

export const locationsReducer: Reducer<LocationState, LocationAction> = (state = initialState, action) => {
    switch (action.type) {
        case LOCATION_RESET:
            return {
                ...initialState
            };

        case LOCATION_ERROR:
            return {
                ...state,
                loading: false,
                status: LocationStatus.Error,
                error: action.payload.error
            };

        case LOCATION_CLEAR_ERROR:
            return {
                ...state,
                status: LocationStatus.Initial,
                error: undefined
            };

        case LOCATION_CLEAR_SUCCESS:
            return {
                ...state,
                status: LocationStatus.Initial,
                savedLocation: undefined
            };

        case LOCATION_FETCH_START:
            return {
                ...state,
                loading: true,
                status: LocationStatus.Fetching,
                error: undefined // Clear previous errors
            };

        case LOCATION_FETCH_SUCCESS:
            // Handle single location fetch
            return {
                ...state,
                loading: false,
                status: LocationStatus.FetchSuccess,
                savedLocation: action.payload.location
            };

        case LOCATIONS_FETCH_SUCCESS:
            // Handle multiple locations fetch
            return {
                ...state,
                loading: false,
                status: LocationStatus.FetchSuccess,
                locations: action.payload.locations,
                pagination: action.payload.pagination
            };

        case LOCATION_SAVE_START:
            return {
                ...state,
                loading: true,
                status: LocationStatus.Saving,
                savedLocation: undefined,
                error: undefined // Clear previous errors
            };

        case LOCATION_SAVE_SUCCESS:
            let locations = [...state.locations];

            if (locations.some(loc => loc.id === action.payload.location.id)) {
                locations = locations.map(loc =>
                    loc.id === action.payload.location.id
                        ? {
                              ...action.payload.location,
                              // Preserve staff_count if API didn't return it (would be undefined)
                              staff_count:
                                  action.payload.location.staffCount !== undefined
                                      ? action.payload.location.staffCount
                                      : loc.staffCount
                          }
                        : loc
                );
            } else {
                locations = [...locations, { ...action.payload.location }];
            }

            // Sort by businessName
            const sortedLocations = locations.sort((a, b) =>
                (a.businessName || '').localeCompare(b.businessName || '')
            );

            return {
                ...state,
                loading: false,
                status: LocationStatus.SaveSuccess,
                locations: sortedLocations,
                savedLocation: { ...action.payload.location }
            };

        default:
            return state;
    }
};

export default locationsReducer;
